import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotPhoneHome = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            fillRule="evenodd"
            d="M21.537 11.75c3.098.707 8.02 1.905 11.607 5.467 3.587 3.574 6.165 9.842 4.148 13.437-2.028 3.584-8.65 4.482-14.484 5.92-5.843 1.448-10.884 3.436-14.41 1.83-3.513-1.608-5.49-6.799-6.54-11.27C.8 22.661.686 18.92 1.715 15.79c1.019-3.13 3.202-5.635 5.687-6.46 2.495-.813 5.302.043 7.517.762 2.215.72 3.51.938 6.62 1.657l-.002.001Z"
            clipRule="evenodd"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeWidth={strokeWidth}
            d="M18.944 13.815H33a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H18.944m-10.016 0H7a2 2 0 0 1-2-2v-18a2 2 0 0 1 2-2h1.928M31 23h-1m1 8h-1m1-4h-1m-9-4h-1m1 4h-1m1 4h-1m6-8h-1m1 4h-1m1 4h-1m6-12H20M9 9c1.934-1.333 5.066-1.333 7 0m2-3c-3.04-2.667-7.96-2.667-11 0m7 7h-3a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2Z"
        />
    </SVG>
);
SpotPhoneHome.displayName = "SpotPhoneHome";
